import { useReduxState } from 'hooks';
import { Link } from 'components/common';

import type { CalendarEvent } from 'shared-types';

interface Props {
  event: Pick<CalendarEvent, 'title' | 'startDate' | 'endDate'>;
  titleLink?: string;
}

const CalendarEventTileHeader = ({ event, titleLink }: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="header">
      <div className="info">
        <div className="info-text">{messages.eventCalendarEvent}</div>
      </div>

      <div className="title">
        {titleLink ? (
          <Link href={titleLink} linkColor="inherit" text={event.title} />
        ) : (
          event.title
        )}
      </div>

      <style jsx>{`
        .info {
          align-items: center;
          display: flex;
          gap: 8px;
        }
        .info-text {
          color: ${theme.textColorLight};
          font-size: 1.3rem;
          font-weight: 600;
        }
        .title {
          color: ${theme.textColor};
          display: -webkit-box;
          font-size: 1.6rem;
          font-weight: 700;
          margin-top: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      `}</style>
    </div>
  );
};

export default CalendarEventTileHeader;
